import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	oneFieldDescription: {
		id: 'project-directories.versions.delete-version.content.one-field-description',
		defaultMessage: 'Deleting this version will remove it from {issueCountLink}.',
		description: '',
	},
	issueCount: {
		id: 'project-directories.versions.delete-version.content.issue-count',
		defaultMessage: '{count} {count, plural, one {issue} other {issues}}',
		description: '',
	},
	multipleFieldsDescription: {
		id: 'project-directories.versions.delete-version.content.multiple-fields-description',

		defaultMessage:
			'A few issue fields reference {name}. You can update the fields to reference another version or clear the value of those fields.',

		description: '',
	},
	affectedVersion: {
		id: 'project-directories.versions.delete-version.content.affected-version',
		defaultMessage: 'Affects version',
		description: '',
	},
	fixVersion: {
		id: 'project-directories.versions.delete-version.content.fix-version',
		defaultMessage: 'Fix version',
		description: '',
	},
});
